import 'src/app/utils/array.extensions';
import 'src/app/utils/map.extensions';
import 'src/app/utils/number.extensions';
import 'src/app/utils/behavior-subject.extensions';
import 'src/app/utils/replay-subject.extensions';
import 'src/app/utils/observable.extensions';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './views/dashboard/components/dashboard/dashboard.component';
import { AuthModule } from './views/auth/auth.module';
import { SidebarNavComponent } from './views/dashboard/components/sidebar-nav/sidebar-nav.component';
import { TemplateModule } from './views/template/template.module';
import { NgbActiveModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AuthInterceptor } from './services/interceptors/auth.interceptor';
import { SharedModule } from './views/shared/shared.module';
import { RouteReuseStrategy } from '@angular/router';
import { CacheRouteReuseStrategy } from './services/strategy/cache-route-reuse.strategy';
import { SidebarSubItemListComponent } from './views/dashboard/components/sidebar-nav/sidebar-sub-item-list/sidebar-sub-item-list.component';
import { NavSubItemComponent } from './views/dashboard/components/sidebar-nav/nav-sub-item/nav-sub-item.component';
import { NavItemComponent } from './views/dashboard/components/sidebar-nav/nav-item/nav-item.component';
import { CurrentLocationNavItemComponent } from './views/dashboard/components/sidebar-nav/nav-item/current-location-nav-item/current-location-nav-item.component';
import { ProductsNavItemComponent } from './views/dashboard/components/sidebar-nav/nav-item/products-nav-item/products-nav-item.component';
import { SettingsNavItemComponent } from './views/dashboard/components/sidebar-nav/nav-item/settings-nav-item/settings-nav-item.component';
import { SignOutNavItemComponent } from './views/dashboard/components/sidebar-nav/nav-item/sign-out-nav-item/sign-out-nav-item.component';
import { ToastModule } from './modules/toasts/toast.module';
import { ProductsSubNavItemComponent } from './views/dashboard/components/sidebar-nav/nav-sub-item/products-sub-nav-item/products-sub-nav-item.component';
import { IsProductsNavItemPipe } from './views/dashboard/components/sidebar-nav/nav-item/pipes/is-products-nav-item.pipe';
import { IsSettingsNavItemPipe } from './views/dashboard/components/sidebar-nav/nav-item/pipes/is-settings-nav-item.pipe';
import { IsSignOutNavItemPipe } from './views/dashboard/components/sidebar-nav/nav-item/pipes/is-sign-out-nav-item.pipe';
import { IsDefaultNavItemPipe } from './views/dashboard/components/sidebar-nav/nav-item/pipes/is-base-nav-item.pipe';
import { IsLocationNavItemPipe } from './views/dashboard/components/sidebar-nav/nav-item/pipes/is-location-nav-item.pipe';
import { IsProductsNavSubItemPipe } from './views/dashboard/components/sidebar-nav/nav-sub-item/pipes/is-products-nav-sub-item.pipe';
import { IsDefaultNavSubItemPipe } from './views/dashboard/components/sidebar-nav/nav-sub-item/pipes/is-default-nav-sub-item.pipe';
import { IncompleteSubNavItemComponent } from './views/dashboard/components/sidebar-nav/nav-sub-item/incomplete-sub-nav-item/incomplete-sub-nav-item.component';
import { IsIncompleteNavSubItemPipe } from './views/dashboard/components/sidebar-nav/nav-sub-item/pipes/is-incomplete-nav-sub-item.pipe';
import { ProfileNavItemComponent } from './views/dashboard/components/sidebar-nav/nav-item/profile-nav-item/profile-nav-item.component';
import { IsProfileNavItemPipe } from './views/dashboard/components/sidebar-nav/nav-item/pipes/is-profile-nav-item.pip';
import { ApplicationSourceInterceptor } from './services/interceptors/application-source-interceptor';
import { ConfirmationModule } from './modules/confirmation/confirmation.module';
import { SmartLabelsModule } from './modules/product-labels/smart-labels/smart-labels.module';
import { CollectionModule } from './views/collection/collection.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxFloatUiModule } from 'ngx-float-ui';
import { HelpNavItemComponent } from './views/dashboard/components/sidebar-nav/nav-item/help-nav-item/help-nav-item.component';
import { IsHelpNavItemPipe } from './views/dashboard/components/sidebar-nav/nav-item/pipes/is-help-nav-item.pip';
import { LiveViewModule } from './views/live-view/live-view.module';
import { RxIf } from '@rx-angular/template/if';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { PageBannerComponent } from './views/dashboard/components/page-banner/page-banner.component';
import { RxPush } from '@rx-angular/template/push';
import { RxLet } from '@rx-angular/template/let';
import { provideRxRenderStrategies } from '@rx-angular/cdk/render-strategies';
import { SideNavFooterComponent } from './views/dashboard/components/sidebar-nav/side-nav-footer/side-nav-footer.component';
import { SideNavHeaderComponent } from './views/dashboard/components/sidebar-nav/side-nav-header/side-nav-header.component';
import { SideNavBodyComponent } from './views/dashboard/components/sidebar-nav/side-nav-body/side-nav-body.component';
import { RxFor } from '@rx-angular/template/for';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    SidebarNavComponent,
    SideNavHeaderComponent,
    SideNavFooterComponent,
    SideNavBodyComponent,
    SidebarSubItemListComponent,
    NavSubItemComponent,
    NavItemComponent,
    CurrentLocationNavItemComponent,
    ProductsNavItemComponent,
    SettingsNavItemComponent,
    ProfileNavItemComponent,
    IsProductsNavItemPipe,
    IsSettingsNavItemPipe,
    IsLocationNavItemPipe,
    IsDefaultNavItemPipe,
    SignOutNavItemComponent,
    HelpNavItemComponent,
    IsSignOutNavItemPipe,
    ProductsSubNavItemComponent,
    IsProductsNavSubItemPipe,
    IsDefaultNavSubItemPipe,
    IncompleteSubNavItemComponent,
    IsIncompleteNavSubItemPipe,
    IsProfileNavItemPipe,
    IsHelpNavItemPipe,
    PageBannerComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    // Do not change the order of AppRoutingModule. If you do, it will mess up the base route url redirect!
    AppRoutingModule,
    AuthModule,
    ToastModule,
    BrowserAnimationsModule,
    BrowserModule,
    BsDropdownModule,
    NgxSpinnerModule,
    ConfirmationModule,
    FlexLayoutModule,
    NgxFloatUiModule,
    SmartLabelsModule,
    TemplateModule,
    CollectionModule,
    SharedModule,
    ToastModule,
    LiveViewModule,
    RxIf,
    RxPush,
    RxLet,
    RxFor,
    NgbTooltip
  ],
  providers: [
    NgbActiveModal,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: RouteReuseStrategy,
      useClass: CacheRouteReuseStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApplicationSourceInterceptor,
      multi: true
    },
    // This is important. It signals parent components of dom changes, which is required to make rx-angular signal
    // @ViewChild, @ViewChildren, @ContentChild, and @ContentChildren in parent components.
    provideRxRenderStrategies({ parent: true }),
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
